import './DashboardSupport.css'

const DashboardSupport = () => {
    return (
        <div className="dashboard-support">
            <h2>Your Resources</h2>
            <br/>
            <h3>Account Manager</h3>
            <p>Spencer Heywood</p>
            <p>Text or Call: <a href="tel:9717771485">(971) 777-1485</a></p>
            <p>Email: <a href="mailto:spencer@bookservo.com">Spencer@bookservo.com</a></p>
            <br/>
            <h3>Purchase Orders</h3>
            <p>Email: <a href="mailto:spencer@bookservo.com">Spencer@bookservo.com</a></p>
            <br/>
            <h3>Message from Servo</h3>
            <p>
                For the meaningful work that you invest in the St George community, 
                <br/>
                Thank you.
            </p>
        </div>
    )
}

export default DashboardSupport;